import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import Header from "./Header";
import Footer from "./Footer";
import AdSlot from "./AdSlot";
import MaintenancePage from "@/pages/MaintenancePage";

export default function PublicLayout() {
  const { loading, error, reload, settings } = useApp();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" role="status" aria-live="polite" aria-label="جارٍ تحميل الموقع">
        <Loader2 className="w-8 h-8 animate-spin text-primary" aria-hidden="true" />
        <span className="sr-only">جارٍ تحميل الموقع…</span>
      </div>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen flex items-center justify-center px-4" dir="rtl">
        <section className="aran-card w-full max-w-lg p-6 text-center" role="alert">
          <h1 className="font-head text-xl font-bold">تعذّر تحميل الموقع</h1>
          <p className="mt-2 text-sm leading-7 text-muted-foreground">
            تعذّر الاتصال بالخدمة حالياً. تحقق من اتصالك وحاول مرة أخرى.
          </p>
          <button
            type="button"
            onClick={reload}
            className="mt-5 rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            إعادة المحاولة
          </button>
        </section>
      </main>
    );
  }

  if (settings.maintenance_mode) {
    return <MaintenancePage />;
  }

  return (
    <div className="min-h-screen flex flex-col relative grain">
      <Header />
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6">
        <AdSlot slotKey="TOP_BANNER" />
      </div>
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
